import { create } from 'zustand';
import { ImoduleFilter, ISortFilter, SORT_ORDER } from 'types/global';
import { IProductList } from 'types/orders';

interface IState {
  sortFilter: ISortFilter;
  setSortFilter: (sortFilter: ISortFilter) => void;
  orderFilters: ImoduleFilter[];
  setOrderFilters: (orderFilters: ImoduleFilter[]) => void;
  listOrdersFinances: IProductList[];
  setListOrdersFinances: (listOrdersFinances: IProductList[]) => void;
  resetOrdersFinancesState: () => void;
}

/**
 * Hook de Zustand para manejar el estado del módulo de finanzas de órdenes.
 * Gestiona filtros, ordenamiento y lista de órdenes para la vista de finanzas.
 */
const useOrdersFinancesModule = create<IState>(set => ({
  sortFilter: { value: SORT_ORDER.DESC },
  setSortFilter: (sortFilter: ISortFilter) => set({ sortFilter }),
  orderFilters: [],
  setOrderFilters: (orderFilters: ImoduleFilter[]) => set({ orderFilters }),
  listOrdersFinances: [],
  setListOrdersFinances: (listOrdersFinances: IProductList[]) => set({ listOrdersFinances }),
  resetOrdersFinancesState: () => {
    set({
      sortFilter: { value: SORT_ORDER.DESC },
      orderFilters: [],
      listOrdersFinances: []
    });
  }
}));

export default useOrdersFinancesModule;
